import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import Spinner from '@ynap/spinner'
import { raygun } from '@ynap/clientside-monitoring'

const bem = new BEMHelper('AuthoriseStep')

class AuthoriseStep extends Component {
    static propTypes = {
        isReadyToOrder: PropTypes.bool,
        paymentParams: PropTypes.object.isRequired,
        fetchCart: PropTypes.func.isRequired,
        updatePaymentMethod: PropTypes.func.isRequired,
        checkout: PropTypes.func.isRequired,
        setCheckoutError: PropTypes.func.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
        }).isRequired,
        messages: PropTypes.shape({
            authoriseStep: PropTypes.shape({
                processingPayment: PropTypes.func.isRequired,
            }).isRequired,
        }).isRequired,
        redirect: PropTypes.string.isRequired,
        cancelRedirect: PropTypes.string.isRequired,
        className: PropTypes.string,
    }

    componentDidMount() {
        const { setCheckoutError, cancelRedirect, fetchCart, history } = this.props
        return fetchCart({ recalculate: false })
            .then(() => this.updatePaymentAndCheckout())
            .catch((error) => {
                setCheckoutError(error)
                raygun.helpers.agent('send', { error, tags: ['Authorise', 'componentDidMount'] })
                history.replace(cancelRedirect)
            })
    }

    updatePaymentAndCheckout() {
        const { updatePaymentMethod, checkout, paymentParams = {}, history, redirect, isReadyToOrder } = this.props
        if (isReadyToOrder && Object.keys(paymentParams).length && paymentParams.authResult !== 'CANCELLED') {
            return updatePaymentMethod(paymentParams)
                .then(() => checkout(undefined, true))
                .then(() => history.replace(redirect))
                .catch((error) => {
                    throw error
                })
        }
        throw new Error(paymentParams.authResult)
    }

    render() {
        const { className, messages } = this.props

        return (
            <div className={bem(null, null, className)}>
                <div className={bem('background')}>
                    <Spinner className={bem('spinner')} />
                    <div className={bem('processingPayment')}>{messages.authoriseStep.processingPayment()}</div>
                </div>
            </div>
        )
    }
}

export default AuthoriseStep
